import { httpGet } from "../http.service";

class ShiftService {
    async fetchListing () {
        return await httpGet<any>("api/v1/admin/shift")
    }
}
const shiftService = new ShiftService()
export { shiftService }